import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { IInfo, IIntersectionStateVectorElement } from "@types"
import { MyTableComponent } from "components"
import { useFetchInterSectionStateVectorQuery } from "../../store/Features/processData/interSectionStateVector-api-slice"

import openIcon from "./selecticon.png"

import { IntersectionPopup } from "./IntersectionPopup"

export const IntersectionState = () => {
 // language translator
 const { t } = useTranslation("translation")

 const { data } = useFetchInterSectionStateVectorQuery()
 const [selectedData, setSelectedData] = useState<any[]>([])
 const [interSectionData, setInterSectionData] = useState<IInfo[]>([])
 const [operatingModeData, setOperatingModeData] = useState<IInfo[]>([])
 const [permissionData, setPermissionData] = useState<IInfo[]>([])
 const [signalData, setSignalData] = useState<IInfo[]>([])
 const [subInterSectionData, setSubInterSectionData] = useState<IInfo[]>([])
 const [modificationData, setModificationData] = useState<IInfo[]>([])
 const [teData, setTeData] = useState<IInfo[]>([])
 const [ptData, setPtData] = useState<IInfo[]>([])
 const [itData, setItData] = useState<IInfo[]>([])
 const [popupId, setPopupId] = useState<number>()
 const [isClose, setIsClose] = useState<boolean>()
 const [isCloseTe, setIsCloseTe] = useState<boolean>()
 const [isClosePt, setIsClosePt] = useState<boolean>()
 const [isCloseIt, setIsCloseIt] = useState<boolean>()
 const [isCloseOperatingMode, setIsCloseOperatingMode] = useState<boolean>()
 const [isCloseSignal, setIsCloseSignal] = useState<boolean>()
 const [isCloseSubInterSection, setIsCloseSubInterSection] = useState<boolean>()
 const [isClosePermission, setIsClosePermission] = useState<boolean>()
 const [isCloseModification, setIsCloseModification] = useState<boolean>()
 const [isEntries, setIsEntries] = useState<boolean>(false)

 const columns = [
  { Header: t("changeTime"), accessor: "time.timestamp" },
  { Header: t("disturbance"), accessor: "disturbance" },
  {
   Header: t("operatingMode"),
   accessor: "operatingmode.mode",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.operatingmode.mode}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        operatingModeHandler(row?.id)
        setPopupId(row?.id)
        setIsCloseOperatingMode(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isCloseOperatingMode &&
      popupId === row.id &&
      operatingModeData.map((single, index) => (
       <div key={index} className="absolute left-[170px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsCloseOperatingMode} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("signalPlan"),
   accessor: "signal_program.program",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.signal_program.program}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        signalHandler(row?.id)
        setPopupId(row?.id)
        setIsCloseSignal(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isCloseSignal &&
      popupId === row.id &&
      signalData.map((single, index) => (
       <div key={index} className="absolute left-[75px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsCloseSignal} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("intersectionState"),
   accessor: "intersection_state.state",

   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.intersection_state.state}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        intersectionHandler(row?.id)
        setPopupId(row?.id)
        setIsClose(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isClose &&
      popupId === row.id &&
      interSectionData.map((single, index) => (
       <div key={index} className="absolute left-[120px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsClose} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("TEon/off"),
   accessor: "te_on_off.state",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.te_on_off.state}</div>

     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        teHandler(row?.id)
        setPopupId(row?.id)
        setIsCloseTe(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isCloseTe &&
      popupId === row.id &&
      teData.map((single, index) => (
       <div key={index} className="absolute left-[63px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsCloseTe} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("PTon/off"),
   accessor: "pt_on_off.state",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.pt_on_off.state}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        ptHandler(row?.id)
        setPopupId(row?.id)
        setIsClosePt(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isClosePt &&
      popupId === row.id &&
      ptData.map((single, index) => (
       <div key={index} className="absolute left-[63px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsClosePt} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("ITon/off"),
   accessor: "it_on_off.state",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.it_on_off.state}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        itHandler(row?.id)
        setPopupId(row?.id)
        setIsCloseIt(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isCloseIt &&
      popupId === row.id &&
      itData.map((single, index) => (
       <div key={index} className="absolute left-[57px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsCloseIt} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("modiFications"),

   Cell: ({ row }: any) => {
    return row.original.modifications?.map((entry: any, index: number) => (
     <div key={index} className="relative ">
      {index === 0 && (
       <div>
        <div>{row.original.modifications?.length + ":entries"}</div>
        <button
         onClick={() => {
          setIsEntries((prev) => !prev)
         }}
         className="bg-golden py-2 px-2 rounded"
        >
         <img
          className={`${isEntries ? "rotate-360" : "rotate-180"}`}
          alt="openIcon"
          src={openIcon}
         />
        </button>
       </div>
      )}

      {isEntries && (
       <div key={index}>
        <h1>{entry.entry_name}</h1>
        <div className="flex justify-center">
         <svg
          className="cursor-pointer"
          onClick={() => {
           modificationHandler(entry.info)
           setPopupId(index)
           setIsCloseModification(true)
          }}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
         >
          <g id="Iconly/Light-Outline/Danger Circle">
           <g id="Danger Circle">
            <path
             id="Fill 1"
             fillRule="evenodd"
             clipRule="evenodd"
             d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
             // fill="#111928"
            />
            <path
             id="Fill 3"
             fillRule="evenodd"
             clipRule="evenodd"
             d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
             // fill="#111928"
            />
            <path
             id="Fill 5"
             fillRule="evenodd"
             clipRule="evenodd"
             d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
             // fill="#111928"
            />
           </g>
          </g>
         </svg>
        </div>

        {isCloseModification &&
         popupId === index &&
         modificationData?.map((single, index) => (
          <div key={index} className="absolute left-[245px] top-0 z-10">
           <IntersectionPopup single={single} hide={setIsCloseModification} />
          </div>
         ))}
       </div>
      )}
     </div>
    ))
   },
  },
  {
   Header: t("subIntersections"),
   accessor: "subintersection.state",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.subintersection.state}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        subInterSectionHandler(row?.id)
        setPopupId(row?.id)
        setIsCloseSubInterSection(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isCloseSubInterSection &&
      popupId === row.id &&
      subInterSectionData.map((single, index) => (
       <div key={index} className="absolute left-[245px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsCloseSubInterSection} />
       </div>
      ))}
    </div>
   ),
  },
  {
   Header: t("specialPreemption"),
   accessor: "special_preemption.value",
   Cell: ({ row }: any) => (
    <div className="relative">
     <div>{row.original.special_preemption.value}</div>
     <div className="flex justify-center ">
      <svg
       className="cursor-pointer"
       onClick={() => {
        permissionHandler(row?.id)
        setPopupId(row?.id)
        setIsClosePermission(true)
       }}
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
      >
       <g id="Iconly/Light-Outline/Danger Circle">
        <g id="Danger Circle">
         <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
          // fill="#111928"
         />
         <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
          // fill="#111928"
         />
         <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
          // fill="#111928"
         />
        </g>
       </g>
      </svg>
     </div>

     {isClosePermission &&
      popupId === row.id &&
      permissionData.map((single, index) => (
       <div key={index} className="absolute left-[140px] top-0 z-10">
        <IntersectionPopup single={single} hide={setIsClosePermission} />
       </div>
      ))}
    </div>
   ),
  },
 ]

 const intersectionHandler = (id: number) => {
  const _duplicate: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicate.push(item?.intersection_state?.info),
  )
  setInterSectionData(_duplicate)
 }

 const teHandler = (id: number) => {
  const _duplicateTE: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicateTE.push(item?.it_on_off?.info),
  )
  setTeData(_duplicateTE)
 }

 const ptHandler = (id: number) => {
  const _duplicatePT: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicatePT.push(item?.pt_on_off?.info),
  )
  setPtData(_duplicatePT)
 }
 const itHandler = (id: number) => {
  const _duplicateIT: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicateIT.push(item?.it_on_off?.info),
  )
  setItData(_duplicateIT)
 }
 const operatingModeHandler = (id: number) => {
  const _duplicateOperatingMode: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicateOperatingMode.push(item?.operatingmode?.info),
  )
  setOperatingModeData(_duplicateOperatingMode)
 }
 const signalHandler = (id: number) => {
  const _duplicateSignal: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicateSignal.push(item?.signal_program?.info),
  )
  setSignalData(_duplicateSignal)
 }
 const subInterSectionHandler = (id: number) => {
  const _duplicateSub: IInfo[] = []
  selectedData?.forEach(
   (item, index) => index === Number(id) && _duplicateSub.push(item?.subintersection?.info),
  )
  setSubInterSectionData(_duplicateSub)
 }
 const permissionHandler = (id: number) => {
  const _duplicatePermission: IInfo[] = []
  selectedData?.forEach(
   (item, index) =>
    index === Number(id) && _duplicatePermission.push(item?.special_preemption?.info),
  )
  setPermissionData(_duplicatePermission)
 }
 const modificationHandler = (info: IInfo) => {
  const _duplicateModification: IInfo[] = []
  _duplicateModification.push(info)
  setModificationData(_duplicateModification)
 }

 useEffect(() => {
  const interSectionArray: IIntersectionStateVectorElement[] = []
  if (data) {
   data.map((single) => {
    return single?.intersection_state_vector_element?.map((data) => interSectionArray?.push(data))
   })

   setSelectedData(interSectionArray)
  }
  // eslint-disable-next-line
 }, [data])

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <h1 className="font-semibold text-2xl Jakarta-font py-6">{t("intersectionState")}</h1>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
